import {useController, useFormContext, useWatch} from 'react-hook-form'

import {OrderChangeConfig} from '../types/OrderChangeConfig'

export const useExtraDistance = () => {
  const {control, setValue} = useFormContext<OrderChangeConfig>()
  const extraDistance = useWatch({control, name: 'cancellation.extraDistance'})
  const {field: threshold} = useController({control, name: 'cancellation.extraDistance.threshold'})
  const {field: extraLeadTime} = useController({
    control,
    name: 'cancellation.extraDistance.extraLeadTime'
  })

  const toggleExtraDistance = (isEnabled: boolean) => {
    if (isEnabled) {
      setValue('cancellation.extraDistance', {isEnabled, threshold: 100, extraLeadTime: 1})
    } else {
      setValue('cancellation.extraDistance', {isEnabled})
    }
  }

  return {
    isEnabled: extraDistance?.isEnabled ?? false,
    threshold,
    extraLeadTime,
    toggleExtraDistance
  }
}
